import APIConfiguration from '@savgroup-front-common/configuration/api';
import { SUPPORTED_METHODS } from '@savgroup-front-common/constants/shared/supportedMethods';
import {
  buildUrl,
  prepareResponseFailure,
} from '@savgroup-front-common/core/helpers';
import { apiCall } from '@savgroup-front-common/core/services';
import {
  BackResponse,
  BackResponseFailure,
  SelfOnboardingActor,
} from '@savgroup-front-common/types';

const ENDPOINT = `${APIConfiguration.actor}selfonboarding/repairers/info`;

interface GetSelfOnboardingRepairersInfoQueryPayload {
  sellerId?: string;
}

async function getSelfOnboardingRepairersInfoQuery({
  sellerId,
}: GetSelfOnboardingRepairersInfoQueryPayload): Promise<
  BackResponse<SelfOnboardingActor[]> | BackResponseFailure
> {
  try {
    const url = buildUrl(ENDPOINT, { sellerId });

    const response = await apiCall<BackResponse<SelfOnboardingActor[]>>(url, {
      method: SUPPORTED_METHODS.GET,
    });

    return response;
  } catch (exception) {
    return prepareResponseFailure(exception);
  }
}

export default getSelfOnboardingRepairersInfoQuery;
